// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    CheckboxesControl,
    InputControl,
    RadioButtonsControl,
    SelectControl,
    DatePickerControl,
} from "../../../molecules";
import {
    Box,
    FormControl,
    Stack,
    Typography,
    Autocomplete,
    TextField,
    useTheme,
    useMediaQuery,
    FormGroup,
    Switch,
    FormLabel,
    FormControlLabel,
    Divider,
    Checkbox,
    Card,
    CardHeader,
    CardContent
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { Button, Loading } from "../../../atoms";
import {
    useGetMerchantCategoryList,
    useMerchantAdd,
    useGetMerchantTypeList,
    useGetPosTypeList,
    useGetAllMerchantList,
    useGetCommissionProfileList,
    useGetCityList,
    useGetTaxAdministrationList,
    useGetMerchantStatusList,
    IMerchantAddRequest,
    IMerchant,
    useMerchantUpdate,
    useAuthorization,
    useGetAnnulmentCodeList,
    useGetIntegrationTypes,
    useGetMerchantUserPortfolioList,
    useGetTrxStatusSettingsList,
    useGetMerchantLimitSettingsList
} from "../../../../hooks";
import { useEffect, useMemo, useState, useRef } from "react";
import { useUserMerchantId } from "../Merchant.state";
import { useSetSnackBar } from "../../../../store/Snackbar.state";
import {
    firstStepFormSchema,
    firstStepFormSchemaPassive,
    FirstStepFormValuesType,
    firstStepInitialValues,
} from "../_formTypes";
import { zodResolver } from "@hookform/resolvers/zod";
import { default as dayjs } from "dayjs";
import { useUserInfo } from "../../../../store/User.state";
import { FamilyRestroom } from "@mui/icons-material";
import { AnyZodTuple } from "zod";

export interface MerchantAddFormLimitSectionFormStates {
    merchant: any;
    control: any;
    formState: any;
    setFormState: any;
    workplaceType: any;
    setValue: any;
}

export const MerchantAddFormLimitSection = ({ merchant, control, formState, setFormState, workplaceType, setValue }: MerchantAddFormLimitSectionFormStates) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

    const [isFirstLoadFinshed, setIsFirstLoadFinshed] = useState(false);

    const { data: rawMerchantLimitSettings, isLoading: isMerchantLimitSettingsLoading } = useGetMerchantLimitSettingsList({});

    useEffect(() => {
        if (!isFirstLoadFinshed) {
            handleChange('hasGiroRestriction', merchant.hasGiroRestriction);
            handleChange('hasAutomaticGiroLimitIncrease', merchant.hasAutomaticGiroLimitIncrease);
            handleChange('giroLimit', merchant.giroLimit);
            setIsFirstLoadFinshed(true);
        }
    }, [merchant])

    const [giroValue, setGiroValue] = useState(merchant.giroLimit);

    const giroInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {

        if (merchant.giroLimit <= 0) {

            let key = workplaceType == 2 ? 'COMMERCIAL_PERCENTAGE' : 'CORPORATE_DEFAULT_LIMIT';

            var value = rawMerchantLimitSettings?.data?.find(x => x.key == key)?.value;

            if (giroInputRef.current) {
                giroInputRef.current.value = value;
                handleChange('giroLimit', value);
                setValue('giroLimit', value);
            }
        }

    }, [workplaceType]);

    const handleChange = <K extends keyof MerchantAddFormAuthorizationSectionFormStates>(
        key: K,
        value: MerchantAddFormAuthorizationSectionFormStates[K]
    ) => {
        setFormState((prevState) => ({
            ...prevState,
            [key]: value
        }));
    };

    return (
        <Box p={isDesktop ? 2 : 1}>
            <Card variant="outlined">
                <CardHeader title="Ciro Limit Ayarları" />
                <CardContent>
                    <Stack spacing={2}>
                        {/* Main Switch */}
                        <Box>
                            <FormControlLabel
                                control={<Switch checked={formState.hasGiroRestriction} onChange={(e) => handleChange('hasGiroRestriction', e.target.checked)} />}
                                label="Ciro Limiti"
                            />
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 4 }}>
                                İşyeri için maksimum ciro limiti belirler.
                            </Typography>
                        </Box>

                        {/* Dependent Controls */}
                        <Box
                            sx={{
                                pl: 4,
                                transition: 'opacity 0.3s',
                                opacity: formState.hasGiroRestriction ? 1 : 0.5,
                                pointerEvents: formState.hasGiroRestriction ? 'auto' : 'none'
                            }}
                        >
                            <Stack spacing={2}>
                                <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                                    <InputControl
                                        id="giroLimit"
                                        name="giroLimit"
                                        defaultValue={giroValue}
                                        control={control}
                                        label="Limit Tutarı (TL)"
                                        numeric
                                        inputRef={giroInputRef}
                                    />
                                </FormControl>
                                <Box>
                                    <FormControlLabel
                                        control={<Switch checked={formState.hasAutomaticGiroLimitIncrease} onChange={(e) => handleChange('hasAutomaticGiroLimitIncrease', e.target.checked)} />}
                                        label="Otomatik Limit Artışı"
                                    />
                                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 4 }}>
                                        Belirlenen periyotlarda ciroya göre limitin otomatik artırılmasını sağlar.
                                    </Typography>
                                </Box>
                            </Stack>
                        </Box>
                    </Stack>
                </CardContent>
            </Card>
        </Box>
    );
}